import { useEffect } from 'react';
import * as signalR from '@microsoft/signalr';

const HUB_BASE = (import.meta.env.VITE_API_URL || 'http://localhost:5000/api').replace(/\/api\/?$/, '');

/**
 * Sipariş hub'ına bağlanır ve verilen olayları dinler.
 * handlers: { 'new-order': fn, 'order-status-changed': fn, ... }
 */
export function useOrderHub(handlers: Record<string, (payload: any) => void>) {
  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token) return;

    const conn = new signalR.HubConnectionBuilder()
      .withUrl(`${HUB_BASE}/hubs/orders`, { accessTokenFactory: () => localStorage.getItem('access_token') || '' })
      .withAutomaticReconnect()
      .build();

    Object.entries(handlers).forEach(([evt, fn]) => conn.on(evt, fn));
    conn.start().catch(() => {});

    return () => { conn.stop(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export const ORDER_STATUS: Record<number, { label: string; color: string }> = {
  1: { label: 'Beklemede', color: '#f59e0b' },
  2: { label: 'Onaylandı', color: '#3b82f6' },
  3: { label: 'Hazırlanıyor', color: '#8b5cf6' },
  4: { label: 'Kurye Bekleniyor', color: '#f97316' },
  5: { label: 'Kurye Atandı', color: '#06b6d4' },
  6: { label: 'Yolda', color: '#0ea5e9' },
  7: { label: 'Teslim Edildi', color: '#22c55e' },
  8: { label: 'İptal Edildi', color: '#ef4444' },
};

export const PAYMENT_METHODS: Record<number | string, string> = {
  1: 'Kapıda Nakit',
  Cash: 'Kapıda Nakit',
  2: 'Kapıda Kredi Kartı (POS)',
  CreditCard: 'Kapıda Kredi Kartı (POS)',
  3: 'Online Kredi Kartı',
  OnlinePayment: 'Online Kredi Kartı',
  OnlineCreditCard: 'Online Kredi Kartı',
  4: 'Metropol',
  Metropol: 'Metropol',
  5: 'Setcard',
  Setcard: 'Setcard',
  6: 'Edenred Ticket',
  EdenredTicket: 'Edenred Ticket',
};

export function StatusBadge({ status }: { status: number }) {
  const s = ORDER_STATUS[status] ?? { label: String(status), color: '#888' };
  return (
    <span style={{ background: s.color + '22', color: s.color, padding: '4px 10px', borderRadius: 999, fontSize: '0.8rem', fontWeight: 600 }}>
      {s.label}
    </span>
  );
}
